<script>
import Input from "@/components/c-input";
import Select from "@/components/c-select";
// import i18n from "../../i18n";

/* eslint-disable no-console */
/**
 * Item List component
 */
export default {
  components: {
    Input,
    Select,
  },
  data() {
    return {
      loanTypeList: {},

      valueAmount: '',
      valueAmountDisplay: '',
      valueInstallmentPayment: 0,
      valueLoanType: 0,
      valueType: 1,

      selectLoanType: true,

    };
  },
  mounted() {

    this.valueInstallmentPayment = this.index + 1;

    if(this.term != null) {
      this.valueAmount = this.term.amount;
      this.valueAmountDisplay = this.term.show;
      this.valueType = this.term.type;
      this.selectLoanType = false;
    }

  },
  methods: {
    
    getResult: function() {

      let amount = this.valueAmount.includes("*") ? 0 : parseFloat(this.valueAmount);
      let type = this.valueAmount.includes("%") ? 1 : this.valueAmount.includes("*") ? 3 : 2;

      return {
        index: this.id,
        amount,
        display: type == 1 ? `${amount}%` : type == 2 ? `${amount}$` : this.valueLoanType == 0 ? this.valueAmount : `${this.valueLoanType}id` ,
        //this.valueType == 1 ? `${this.valueAmount}%` : this.valueType == 2 ? `${this.valueAmount}$` : this.valueLoanType == 0 ? this.valueAmount : `${this.valueLoanType}id` ,
        installment_payment: this.valueInstallmentPayment,
        loan_type_id: this.valueLoanType,
        type
      };
    },

    getValue: function() {
      return this.valueAmount;
    },

    setValue: function(value) {
      // console.log(value);
      this.valueAmountDisplay = value;
    },

    isNumber: function(val) {
      return /^[0-9]+(\.)?[0-9]*$/.test(val);
    },

    getDisplay: function() {
      return (this.valueAmount == "*") ? this.valueAmountDisplay : this
    },

    selectType: function(event) {
      if(event == 3) {
        this.valueAmount = "*";
        this.selectLoanType = false;
      } else {
        this.selectLoanType = true;
        this.valueAmount = "";
      }
    }
    
  },
  props: {
    term: null,

    index: {
      type: Number,
      default: 0
    },
    loanTypeData: [],
    typeData: [],

  },
};
</script>
<template>
  <div class="row">
    <div class="col-md-6">
      <div v-if="valueAmount == '*'">
        <Input 
          :type="'text'"
          :id="`amount_${index}`"
          v-on:input="$emit('input', $event)"
          v-model="valueAmountDisplay"
          /> 
      </div>
      <div v-else>
        <Input 
          :type="'text'"
          :id="`amount_${index}`"
          v-on:input="$emit('input', $event)"
          v-model="valueAmount"
          /> 
      </div>
    </div>
    <!-- <div  class="col-md-2">
      <Select 
                :text="'name'"
        :auto="true"
        :id="`type_${index}`"
        :list="this.typeData"
        v-model="valueType"
      /> 
    </div> -->
    <div class="col-md-3">
      <Input 
        :type="'number'"
        :id="`installment_payment_${index}`"
        :disabled="true"
        v-model="valueInstallmentPayment"
        /> 
    </div>
    <div class="col-md-3">
      <Select 
                :text="'name'"
        :id="`loan_type_${index}`"
        :text2="'name_en'"
        :list="this.loanTypeData"
        v-model="valueLoanType"
        :disabled="selectLoanType"
      /> 
    </div>
  </div>
</template>